export const SET_ANONYMOUS_OFFERS_LIST = 'SET_ANONYMOUS_OFFERS_LIST';
